import { jwtDecode } from "jwt-decode";

export const isExpiredToken = (token: string): boolean => {
  const decodedToken: { exp: number } = jwtDecode(token);
  const currentDate = new Date();

  if (decodedToken.exp * 1000 < currentDate.getTime()) {
    return true;
  }

  return false;
};
